export default "__VITE_ASSET__wszW16A6__"